const Local = "https://medtest.utkarshh.in/";
export const HostName = "medtest.utkarshh.in";
export const Host = Local;
